/********************************************************************
 * Project: WDCK（2021）
 * Class: ExamCourseSelDTO
 * ----------------------------------------
 * <summary>
 * ExamCourseSelDTO
 * </summary>
 * <history>
 *      ThaiTV     2022/01/05      Create
 * </history>
 ********************************************************************/
export class ExamCourseSelDTO {
    HTCourseName: string;
    HTCourseCode: string;
    CoCode: string;
    PersonalReqPrice: string;
    ListOption: OptionDTO[];
    ListOptionCommon: OptionDTO[];
    TotalPrice: number;
    AgeCalculateDiv: string;
    PersonFamilyDiv: string;
    CoReqPrice: string;
    InsuranceReqPrice: string;
    OtherReqPrice: string;
    InsuranceReqUpLimitPrice: string;
    UplimitCorrectPriceDiv: string;
    CoReqUpLimitPrice: string;
    OtherReqUpLimitPrice: string;
    HTCourseDiv: string;
    OddEvenAgeDiv: string;
    AgeLowLimit: string;
    AgeUpLimit: string;
}
export class OptionDTO {
    HTOptionName: string;
    HTSetItemCode: string;
    /*20240402 #21672 add start*/ 
    HTItemCode: string;
    /*20240402 #21672 add end*/ 
    PersonalReqPrice: string;
    /* 20241108 #20724 add start */
    Gender: string;
    /* 20241108 #20724 add end */
}

export class Option {
    AgeLowLimit: string = null;
    AgeUpLimit: string = null;
    CoReqPrice: string = null;
    Gender: string = null;
    HTCourseCode: string = null;
    HTOptionName: string = null;
    HTOrgCode: string = null;
    HTSetItemCode: string = null;
    InsuranceReqPrice: string = null;
    OddEvenAgeDiv: string = null;
    OtherReqPrice: string = null;
    PersonFamilyDiv: string = null;
    PersonalReqPrice: string = null;
}